export type IllustrationName =
  | 'symmetry'
  | 'percentage'
  | 'harmony'
  | 'contrast'
  | 'organization'
  | 'dialogue'
  | 'balance'
  | 'communication'
  | 'movement'
  | 'diagram'
  | 'meetings'
  | 'increasing'
  | 'decreasing'
  | 'star'
  | 'heart'
  | 'steps'
  | 'focus'
  | 'talking';

export type IllustrationVariant =
  | 'plain'
  | 'gradient'
  | 'transparent'
  | 'transparent-solid'
  | 'transparent-gradient';

export type IllustrationColorScheme = 'pine' | 'iris' | 'coral' | 'azur';

export type IllustrationSize = 'small' | 'medium' | 'large' | 'mega' | number;

export type IllustrationAnimation = 'pop';

export const ILLUSTRATION_SIZE_MAP: Record<string, number> = {
  small: 80,
  medium: 160,
  large: 240,
  mega: 300,
};

export interface IllustrationColorPair {
  foreground: string;
  background: string;
}

export const ILLUSTRATION_COLOR_SCHEMES: Record<IllustrationColorScheme, IllustrationColorPair> = {
  pine: {
    foreground: 'var(--forma-pine-green)',
    background: 'var(--forma-pine-green-light)',
  },
  iris: {
    foreground: 'var(--forma-iris)',
    background: 'var(--forma-iris-medium)',
  },
  coral: {
    foreground: 'var(--forma-brand-coral)',
    background: 'var(--forma-brand-tiny-coral)',
  },
  azur: {
    foreground: 'var(--forma-brand-azur)',
    background: 'var(--forma-brand-tiny-azur)',
  },
};

export function getIllustrationSize(size: IllustrationSize): number {
  if (typeof size === 'number') return size;
  return ILLUSTRATION_SIZE_MAP[size] ?? 160;
}
